import {Collection} from '@blesk-frontend/api';
import {Button, useModal} from '@blesk-frontend/ui';

import {CollectionFillModal} from './CollectionFillModal';

export const CollectionFillButton = ({collection}: {collection: Collection}) => {
  const openCollectionGuidesModal = useModal((props) => (
    <CollectionFillModal collection={collection} {...props} />
  ));

  return (
    <Button className="px-6" onClick={() => openCollectionGuidesModal()}>
      Собрать коллекцию
    </Button>
  );
};
